import Vue from 'vue';
import App from './App';
import router from './router';

import SvgIcon from 'vue-svgicon'
import '@/assets/icons';
import VueCurrencyFilter from 'vue-currency-filter';

import store from './store';

/* ========== COMPONENTS ============ */

Vue.config.productionTip = false;

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';

import '@/styles/index.scss'; // Global CSS
Vue.use(Element, {locale});

Vue.use(SvgIcon, {
    tagName: 'svgicon'
});
/* ========== FILTERS ============ */

import * as filters from './filters'; // Global filters

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.use(VueCurrencyFilter,
    {
        symbol: "$",
        thousandsSeparator: ",",
        fractionCount: 2,
        fractionSeparator: ".",
        symbolPosition: "front"
    }
);

/* ========== APP ============ */

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
});
